import {
	Component,
	ViewEncapsulation,
	ViewChild,
	Input,
	ChangeDetectorRef
} from '@angular/core';

import { ApplicationService } from '../services/application.service';
import { EventsService } from '@coreui/services/event.service'
import { UINavigation } from '@coreui/services/ui.navigation.service';

@Component({
	selector: 		'modal-contaimer',
	encapsulation: ViewEncapsulation.None,

	template:	`

			<div [ngSwitch]=this._modal>

				<div *ngSwitchCase="'sample-modal'">
					<uicore-signin-modal></uicore-signin-modal>
				</div>

				<div *ngSwitchCase="'sample-overlay'">
			<!--		<navigation-drawer-modal
						[data]=this.applicationService.navigationDrawer()
						(clicked)=handleNavDrawerClicked($event)>
					</navigation-drawer-modal> -->
					<navigation-drawer-nested-modal
						[data]=this.applicationService.navigationDrawerMenu()
						(clicked)=handleNavDrawerClicked($event)>
					</navigation-drawer-nested-modal>
				</div>

			</div>

	`,

})


export class Modals {

	_modal: string = ""
	private eventsService: EventsService
	applicationService: ApplicationService
	uiNavigation: UINavigation


	constructor(_eventsService: EventsService, 
			private _applicationService: ApplicationService,
			private _uiNavigation: UINavigation) {
		this.eventsService = _eventsService
		this.applicationService = _applicationService
		this.uiNavigation = _uiNavigation

		let self = this;
		self.eventsService.on('onShowModalOverlay', function (args: any) {
			self._modal = args.id
		});

		self.eventsService.on('onHideModalOverlay', function (args: any) {
			self._modal = ""
		});

	}

	ngOnInit() {
	}

	ngOnDestroy() {
	}

	ngAfterViewInit() {

	}


	handleNavDrawerClicked(rec: any) {
		this.applicationService.navigationDrawer().setActive(rec.id, true)
		this.uiNavigation.activeView = rec.id
	}

}
